import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";
import {EngineConfig} from "../DB/engineConfigs/@EngineConfig";

const MTClass = EngineConfig;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddEngineConfig extends Command<{entry: MT}, {id: string}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "creator", "createdAt"], makeOptional_all: true}),
		// alternative, used for edit-json dialog (lets you delete properties, including old ones no longer in schema)
		newData: {type: "object"},
	}),
})
export class UpdateEngineConfig extends Command<{id: string, updates?: Partial<MT>, newData?: MT}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteEngineConfig extends Command<{id: string}, {}> {}